'use strict';

class RcmFatGoogle {
    constructor(fat) {
        this.fat = fat;

        // Google parameters
        this.appKey = 'AIzaSyAd48rcKKj3PUXti2XXU0VDxbrwsE7bNvs';

        // Captcha parameters
        this.captchaApiKey = '6LcX5l8UAAAAAMXeovAyUcJtmWnPKwJQGdzM61rO';
        this.captchaSelectorId = 'google-recaptcha';

        // Captcha variables
        this.captchaWidgetId = null;

        // Methods
        if (this.fat.form) {
            this.onAutocomplete();
        }
    }

    // On autocomplete
    onAutocomplete() {
        var self = this;

        var options = { componentRestrictions: { country: ['ca', 'us'] } };
        var input = this.fat.form.geoField[0];

        this.autocomplete = new google.maps.places.Autocomplete(input, options);

        // Google listener
        this.autocomplete.addListener('place_changed', function () {
            var place = self.autocomplete.getPlace();

            if (!place || !place.geometry || !place.address_components) {
                self.fat.form.geoField.data('geoCountry', null);
                self.fat.form.geoField.data('geoLat', null);
                self.fat.form.geoField.data('geoLng', null);
                self.fat.form.geoPlaceField.val('');
            } else {
                $(place.address_components).each(function (index, value) {
                    if (value.types.indexOf('country') != -1) {
                        self.fat.form.geoField.data('geoCountry', value.short_name);
                    }
                });

                self.fat.form.geoField.data('geoLat', place.geometry.location.lat());
                self.fat.form.geoField.data('geoLng', place.geometry.location.lng());
                self.fat.form.geoPlaceField.val(place.place_id);
            }
        });

        input.addEventListener('keydown', (e) => {
            if (e.which === 13) {
                e.preventDefault();
            }
        });
    }

    // Pre populate the autocomplete field with place
    prePopulateAutocomplete(placeId, callback) {
        var self = this;
        var service = new google.maps.places.PlacesService(document.createElement('div'));

        service.getDetails({ placeId: placeId }, function (place, status) {
            if (status == google.maps.places.PlacesServiceStatus.OK) {
                self.autocomplete.set('place', place);
                self.fat.form.geoField.val(place.formatted_address);

                // filter inputs
                if (self.fat.resultsFilters.locationFieldAutocomplete) self.fat.resultsFilters.locationFieldAutocomplete.set('place', place);
                $(self.fat.resultsFilters.locationFieldSelector).val(place.formatted_address);

                if (callback) {
                    callback.call(this);
                }
            }
        });
    }

    // Update Google Analytics tracking
    updateGoogleAnalytics(data, isProfile) {
        var actionObj = {};
        var action = '';

        // Fields
        this.fat.form.urlFields.each(function () {
            var field = $(this);
            actionObj[field.attr('name')] = $.trim(field.val());
        });

        // Facets non-fields
        $(this.fat.algolia.searchSettings.facetFilters).each(function (index, value) {
            var value = value.split(':');

            if (actionObj[value[0]]) {
                actionObj[value[0]] += ',' + value[1];
            } else {
                actionObj[value[0]] = value[1];
            }
        });

        // If is profile
        if (isProfile) {
            actionObj['id'] = data;
        }

        // Object to string
        Object.keys(actionObj).forEach(function (key, index) {
            if (action != '') {
                action += ', ';
            }

            action += key + '=' + actionObj[key];
        });

        // If is profile
        if (isProfile) {
            this.trackGoogleAnalyticsEvent('Find a Teacher V2 Results', action, data);
        // If is result search
        } else {
            this.trackGoogleAnalyticsEvent('Find a Teacher V2 Profile', action, data);
        }

        // Console debug
        if (console && console.log) {
            console.log('RcmFatGoogle.updateGoogleAnalytics', action, actionObj);
        }
    }

    // Track Google ANalytics event
    trackGoogleAnalyticsEvent(category, action, label) {
        if ('undefined' !== typeof dataLayer) {
            dataLayer.push({
                'event': 'eventTracking',
                'eventCategory': category,
                'eventAction': action,
                'eventLabel': label
            });
        }
    }

    // Add/render Google recaptcha
    renderRecaptcha(breakpoint) {
        if ('undefined' == typeof grecaptcha) {
            return false;
        }

        let options = {};
        options['sitekey'] = this.captchaApiKey;

        if (breakpoint && breakpoint.trim() != '') {
            // check breakpoints and render the captcha as compact for smaller screens
            options['size'] = Foundation.MediaQuery.atLeast(breakpoint) ? 'normal' : 'compact';
        }

        $(this.fat.profileForm.selector).find(`#${this.captchaSelectorId}`).remove();
        $(this.fat.profileForm.selector).find('input[type="submit"]').before(`<div id="${this.captchaSelectorId}" class="fatv2-form-row"></div>`);
        this.captchaWidgetId = grecaptcha.render(this.captchaSelectorId, options);
    }
}
